module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header page-hdr"
  }, [_c('div', {
    staticClass: "page-hdr-left"
  }, [_c('h1', [_vm._v(_vm._s(_vm.action) + " AI Audience")]), _vm._v(" "), (_vm.showContext && _vm.context.customer) ? _c('span', {
    staticClass: "cust-ctx-pill"
  }, [_vm._v(_vm._s(_vm.context.customer)), (_vm.context.country) ? [_vm._v(" · " + _vm._s(_vm.context.country))] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "page-tab-bar"
  }, [_c('div', {
    staticClass: "page-tab",
    class: {
      active: _vm.pageTab === 'build'
    },
    on: {
      "click": function($event) {
        _vm.pageTab = 'build'
      }
    }
  }, [_vm._v("🧠 Build Audience")]), _vm._v(" "), _c('div', {
    staticClass: "page-tab",
    class: {
      active: _vm.pageTab === 'library'
    },
    on: {
      "click": function($event) {
        _vm.pageTab = 'library'
      }
    }
  }, [_vm._v("\n      📚 Segment Library "), (_vm.segmentCount !== null) ? _c('span', {
    staticClass: "pt-count"
  }, [_vm._v(_vm._s(_vm.segmentCount))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBuild),
      expression: "showBuild"
    }]
  }, [(!_vm.editing) ? _c('div', {
    staticClass: "tab-bar"
  }, [_c('div', {
    staticClass: "tab",
    class: {
      active: _vm.mode === 'build'
    },
    on: {
      "click": function($event) {
        _vm.mode = 'build'
      }
    }
  }, [_vm._v("🧠 Build with filters")]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.mode === 'upload'
    },
    on: {
      "click": function($event) {
        _vm.mode = 'upload'
      }
    }
  }, [_vm._v("⬆ Upload CSV")])]) : _vm._e(), _vm._v(" "), _c('Form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'build'),
      expression: "mode === 'build'"
    }],
    key: _vm.formKey,
    on: {
      "segment-saved": _vm.onSegmentSaved,
      "context-changed": function($event) {
        _vm.context = $event
      }
    }
  }), _vm._v(" "), (_vm.mode !== 'build') ? [_c('div', {
    staticClass: "upload-sub-toggle"
  }, [_c('button', {
    staticClass: "upload-sub-chip",
    class: {
      'upload-sub-chip-active': _vm.uploadType === 'existing'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.uploadType = 'existing'
      }
    }
  }, [_vm._v("Existing users (Account ID CSV)")]), _vm._v(" "), _c('button', {
    staticClass: "upload-sub-chip",
    class: {
      'upload-sub-chip-active': _vm.uploadType === 'new'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.uploadType = 'new'
      }
    }
  }, [_vm._v("New users (Google Sheet)")])]), _vm._v(" "), (_vm.uploadType === 'existing') ? _c('UploadAudiencePanel', {
    on: {
      "segment-saved": function($event) {
        _vm.segmentsRefreshToken++
      }
    }
  }) : _c('NewUsersUploadPanel', {
    on: {
      "segment-saved": function($event) {
        _vm.segmentsRefreshToken++
      }
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('SegmentLibrary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showBuild),
      expression: "!showBuild"
    }],
    attrs: {
      "refresh-token": _vm.segmentsRefreshToken
    },
    on: {
      "count-changed": function($event) {
        _vm.segmentCount = $event
      }
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Audience Builder")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Generate AI Audience")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-57899472","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audience-builder/ai-audience/index.vue
// module id = FfEW
// module chunks = 1